<template>
  <div>
    <button
      :aria-expanded="isOpen"
      :aria-controls="contentId"
      class="flex items-center gap-1 text-xs text-gray-400 transition-colors hover:text-gray-500"
      @click="isOpen = !isOpen"
    >
      <span>{{ t('ThinkingProcess') }}</span>
      <ChevronDown
        v-if="isOpen"
        class="h-3 w-3"
      />
      <ChevronRight
        v-else
        class="h-3 w-3"
      />
    </button>
    <div
      v-if="isOpen"
      :id="contentId"
      class="mt-1"
    >
      <p class="text-xs italic leading-relaxed text-gray-400">{{ thinking }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, getCurrentInstance } from 'vue'
  import { ChevronDown, ChevronRight } from 'lucide-vue-next'
  import { useTranslation } from '@/composables/useTranslation'

  defineProps<{
    thinking: string
  }>()

  const { t } = useTranslation({
    en: { ThinkingProcess: 'Thinking process' },
    de: { ThinkingProcess: 'Denkprozess' },
    fr: { ThinkingProcess: 'Processus de réflexion' }
  })

  const contentId = `thinking-content-${getCurrentInstance()!.uid}`
  const isOpen = ref(false)
</script>
